import gql from 'graphql-tag';

const SessionQuery = gql`
  query Session($sessionId: String!) {
    session(sessionId: $sessionId) {
      id
      email
      tenant {
        id
        subdomain
        sitePlan
        name
        siteBuilderThemeId
        isShopifyLead
        onboardingChecklist {
          showOnboardingModal
        }
      }
    }
  }
`;

export default SessionQuery;
